// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListOrgHierarchyRelationsQueryVariables = Types.Exact<{
  countryIds: Types.InputMaybe<Array<Types.Scalars['CountryCode']['input']> | Types.Scalars['CountryCode']['input']>;
  companyId: Types.InputMaybe<Types.Scalars['ID']['input']>;
  businessUnitId: Types.InputMaybe<Types.Scalars['ID']['input']>;
  departmentId: Types.InputMaybe<Types.Scalars['ID']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListOrgHierarchyRelationsQuery = { __typename?: 'Query' } & {
  listOrgHierarchyRelations: { __typename?: 'OrgHierarchyRelationList' } & Pick<
    Types.OrgHierarchyRelationList,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'OrgHierarchyRelation' } & Pick<
          Types.OrgHierarchyRelation,
          'id' | 'remarks' | 'createdAt' | 'updatedAt'
        > & {
            company: { __typename?: 'Company' } & Pick<
              Types.Company,
              'id' | 'name' | 'enabled' | 'preferredLanguage'
            > & { country: { __typename?: 'Country' } & Pick<Types.Country, 'name'> };
            businessUnit: Types.Maybe<
              { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'id' | 'name' | 'enabled'> & {
                  definitions: Array<
                    { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'content'>
                  >;
                }
            >;
            department: Types.Maybe<
              { __typename?: 'Department' } & Pick<Types.Department, 'id' | 'name' | 'enabled'> & {
                  definitions: Array<
                    { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'content'>
                  >;
                }
            >;
          }
      >;
    };
};

export const ListOrgHierarchyRelationsDocument = /*#__PURE__*/ gql`
    query listOrgHierarchyRelations($countryIds: [CountryCode!], $companyId: ID, $businessUnitId: ID, $departmentId: ID, $keyword: String) {
  listOrgHierarchyRelations(
    countryIds: $countryIds
    companyId: $companyId
    businessUnitId: $businessUnitId
    departmentId: $departmentId
    keyword: $keyword
  ) {
    items {
      id
      company {
        id
        name
        enabled
        preferredLanguage
        country {
          name
        }
      }
      businessUnit {
        id
        name
        enabled
        definitions {
          languageCode
          content
        }
      }
      department {
        id
        name
        enabled
        definitions {
          languageCode
          content
        }
      }
      remarks
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useListOrgHierarchyRelationsQuery__
 *
 * To run a query within a React component, call `useListOrgHierarchyRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrgHierarchyRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrgHierarchyRelationsQuery({
 *   variables: {
 *      countryIds: // value for 'countryIds'
 *      companyId: // value for 'companyId'
 *      businessUnitId: // value for 'businessUnitId'
 *      departmentId: // value for 'departmentId'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListOrgHierarchyRelationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>(
    ListOrgHierarchyRelationsDocument,
    options,
  );
}
export function useListOrgHierarchyRelationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>(
    ListOrgHierarchyRelationsDocument,
    options,
  );
}
// @ts-expect-error
export function useListOrgHierarchyRelationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListOrgHierarchyRelationsQuery,
    ListOrgHierarchyRelationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>;
export function useListOrgHierarchyRelationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListOrgHierarchyRelationsQuery | undefined, ListOrgHierarchyRelationsQueryVariables>;
export function useListOrgHierarchyRelationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>(
    ListOrgHierarchyRelationsDocument,
    options,
  );
}
export type ListOrgHierarchyRelationsQueryHookResult = ReturnType<typeof useListOrgHierarchyRelationsQuery>;
export type ListOrgHierarchyRelationsLazyQueryHookResult = ReturnType<typeof useListOrgHierarchyRelationsLazyQuery>;
export type ListOrgHierarchyRelationsSuspenseQueryHookResult = ReturnType<
  typeof useListOrgHierarchyRelationsSuspenseQuery
>;
